import React from 'react';

const ctaFeatures = [
  {
    icon: '🎳',
    title: 'Open Bowling',
    description: 'Walk in and enjoy a game anytime! Lane availability on a first-come, first-served basis.',
  },
  {
    icon: '🎉',
    title: 'Parties & Events',
    description: 'From kids birthdays to corporate outings, we make every event special and memorable.',
  },
  {
    icon: '🏆',
    title: 'Leagues & Tournaments',
    description: 'Join our competitive leagues or sign up for exciting tournament events throughout the year.',
  },
];

function CTA() {
  return (
    <section className="cta-section" id="contact">
      <div className="container">
        <h2>Ready to Roll?</h2>
        <p>
          Book your lanes today and experience the best bowling entertainment in the Poconos.
          Whether it's a casual night out or a special event, SkyLanes has you covered.
        </p>
        <a href="tel:+15704217680" className="btn">
          Call Us Now
        </a>
        <div className="cta-features">
          {ctaFeatures.map((feature, index) => (
            <div className="cta-feature" key={index}>
              <div className="cta-feature-icon">{feature.icon}</div>
              <h4>{feature.title}</h4>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CTA;
